import getToken from "../../utils/getToken"
import { API } from "../../config/api"

export default async (data) => {
    try{
        const token = getToken()

        const response = await fetch(`${API}/reviews`,{
            method:'POST',
            headers:{
                'Authorization': `Bearer ${token}`
            },
            body:data
        })

        const {success,review} = await response.json()

        return {success,review}
    }catch(error){
        console.log(error)

        return {success:false}
    }
}